import * as globals from '@wandb/weave/common/css/globals.styles';
import TextareaAutosize from 'react-textarea-autosize';
import styled, {css} from 'styled-components';

import {REPORT_FONT_SIZE} from '../constants';

export const InlineLatexError = styled.span<{selected?: boolean}>`
  border-radius: 4px;
  color: ${globals.THEME.statusErrorText};
  ${props =>
    props.selected &&
    css`
      box-shadow: 0 0 0 2px light-dark(rgb(208, 225, 252), var(--blue-700));
    `}
`;

export const InlineLatexPlaceholder = styled.span<{selected?: boolean}>`
  border-radius: 4px;
  color: ${globals.THEME.textTertiary};
  ${props =>
    props.selected &&
    css`
      box-shadow: 0 0 0 2px light-dark(rgb(208, 225, 252), var(--blue-700));
    `}
`;

export const InlineLatex = styled.span<{selected?: boolean}>`
  border-radius: 4px;
  ${props =>
    props.selected &&
    css`
      box-shadow: 0 0 0 2px light-dark(rgb(208, 225, 252), var(--blue-700));
    `}
`;

export const BlockLatexWrapper = styled.div`
  text-align: center;
  margin-bottom: ${Math.floor(REPORT_FONT_SIZE * 0.8)}px;
`;

export const EditLatexWrapper = styled.div`
  border-radius: 4px;
`;

export const LatexInput = styled(TextareaAutosize)`
  font-family: Inconsolata;
  display: block;
  width: 240px;
  padding: 8px;
  border: 1px solid ${globals.THEME.border};
  border-radius: 4px;
  background: ${globals.THEME.bgSurfaceRaised};
  outline: none;
`;
